import React from "react";
import { Box, Typography } from "@mui/material";
import featureImage from "url:src/assets/images/features_result_investment.png";
import Section from "src/components/Section";
import AppDownloadCta from "../components/AppDownloadCta";
import { useResultPage } from "../hooks";
import CaseSection from "src/components/CaseSection";
import FAQSection from "src/components/FAQSection";
import theme from "src/styles/theme";
import ResultHeader from "src/components/ResultHeader";

export default function ResultForInvestmentPage() {
  const { minPrice, maxPrice } = useResultPage();

  return (
    <>
      <ResultHeader backgroundType="investment_result">
        <Box
          sx={{
            width: "353px",
            height: "211px",
            bgcolor: "white",
            justifyContent: "center",
            borderRadius: "4px",
            boxShadow: "0px 4px 10px 0px rgba(66, 71, 80, 0.25)",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="flex-end" gap={1} py={2}>
            <Typography
              fontSize="40px"
              fontWeight="bold"
              sx={{
                background: "linear-gradient(337deg, #FF6232 -9.47%, #FF9347 125.83%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                display: "inline-block",
                lineHeight: 1.3,
              }}
            >
              {minPrice}〜{maxPrice}
            </Typography>
            <Typography color={theme.palette.text.primary} fontWeight="bold" fontSize="20px" component="span">
              万円
            </Typography>
          </Box>

          <Box px={2} pt={1} pb={2}>
            <Typography fontSize="12px" fontWeight="bold" color={theme.palette.text.primary} textAlign={"left"}>
              【重要】AI査定について
            </Typography>
            <Typography fontSize="12px" color={theme.palette.text.primary} textAlign={"left"}>
              このAI査定は、地域の取引データと登録いただいた物件情報をもとに算出した簡易査定です。 <br />
              不動産投資には様々な要素が影響するため、より詳細な分析には実際の査定が必要です
            </Typography>
          </Box>
        </Box>
      </ResultHeader>

      {/* AI査定説明セクション */}
      <Section sx={{ p: 0 }}>
        <img src={featureImage} alt="Agent Icon" style={{ display: "block", margin: "0 auto", width: "100%" }} />
      </Section>

      {/* CTAセクション */}
      <Section sx={{ p: 0 }}>
        <AppDownloadCta />
      </Section>

      {/* 成約事例セクション */}
      <Section title="成約事例">
        <CaseSection />
      </Section>

      {/* よくある質問セクション */}
      <Section title="よくある質問" colored>
        <FAQSection colored />
      </Section>

      {/* CTAセクション */}
      <Section sx={{ px: 0, py: 0, pb: "30px" }} colored>
        <AppDownloadCta />
      </Section>
    </>
  );
}
